/* Light/dark mode. Loaded in <head> without defer so the right colors paint first.
   Default follows the shopper's clock (dark 7pm-7am); the toggle overrides it for the visit. */
(function () {
  var KEY = 'nela-mode';
  function manual() {
    try {
      return sessionStorage.getItem(KEY);
    } catch (e) {
      return null;
    }
  }
  function isNight() {
    var h = new Date().getHours();
    return h >= 19 || h < 7;
  }
  function apply() {
    var m = manual();
    var light = m ? m === 'light' : !isNight();
    document.documentElement.classList.toggle('light', light);
    document.querySelectorAll('[data-mode-toggle]').forEach(function (b) {
      b.textContent = light ? b.dataset.dark : b.dataset.light;
    });
  }
  window.NelaMode = {
    apply: apply,
    toggle: function () {
      var light = !document.documentElement.classList.contains('light');
      try {
        sessionStorage.setItem(KEY, light ? 'light' : 'dark');
      } catch (e) {}
      apply();
    },
  };
  apply();
  setInterval(function () {
    if (!manual()) apply();
  }, 300000);
})();
